import React from 'react';
import './VoucherDetail.scss';
const VoucherDetail = props => {
  const {
    voucherDetails,
    close,
    voucherCode,
    dataLocale: { BALANCE, EMAIL_ID, EXPIRED_AT, CLOSE },
  } = props;
  return (
    <div className="voucher-detail">
      <table className="table table-hover">
        <tbody>
          <tr>
            <td>{voucherCode.title}</td>
            <td className="bold">{voucherCode.code}</td>
          </tr>
          <tr>
            <td>{BALANCE}</td>
            <td className="bold">
              {voucherDetails.balance} {voucherDetails.currency}
            </td>
          </tr>
          <tr>
            <td>{EMAIL_ID}</td>
            <td className="bold">{voucherDetails.customerEmail}</td>
          </tr>
          <tr>
            <td>{EXPIRED_AT}</td>
            <td className="bold">
              {voucherDetails.expiredAt
                ? new Date(voucherDetails.expiredAt).toString().slice(0, 15)
                : ''}
            </td>
          </tr>
        </tbody>
      </table>
      <div style={{ textAlign: 'right' }}>
        <button className="btn btn-default margin-15" type="button" onClick={close}>
          {CLOSE}
        </button>
      </div>
    </div>
  );
};

export default VoucherDetail;
